import { GET_ERRORS, EMPTY_ERRORS, GET_SITE_SETTINGS, BEFORE_SITE_SETTINGS } from '../types';

import { ENV } from '../../config/config';

export const emptyError = () => {
    return {
        type: EMPTY_ERRORS
    }
}

export const beforeSiteSettings = () => {
    return {
        type: BEFORE_SITE_SETTINGS
    }
}

export const getSiteSetting = () => dispatch => {
    dispatch(emptyError());
    fetch(ENV.url + `setting/get?urls=1`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'Authorization': ENV.Authorization,
            'x-auth-token': ENV.x_auth_token
        }
    }).then(res => res.json()).then(data => {
        if (data.success) {
            dispatch({
                type: GET_SITE_SETTINGS,
                payload: data
            })
        } else {
            dispatch({
                type: GET_ERRORS,
                payload: data
            })
        }
    }).catch(errors => {
        dispatch({
            type: GET_ERRORS,
            payload: errors
        })
    })
}